import React from 'react'
import style from './Loader.module.css'

const Loader = ({ color = '#FFF' }) => (
  <span 
    className={style.loader}
    style={{ '--loader-color': color }}
  ></span>
);

export default Loader;